module.exports = __webpack_public_path__ + "static/media/novartis.d74554e1.png";